import { render } from "./close.svg?vue&type=template&id=68711ab8"
const script = {}
script.render = render

export default script